import AdminSignin from '@features/Admin/components/signin/signin.module';

const AdminLogin = () => {
  return <AdminSignin />;
};

export default AdminLogin;
